import { COMMON_ACTION_BUTTONS } from '../../common/common-actions';

export const HAWKER_PROFILE_ACTION_BUTTONS = [
  {
    ...COMMON_ACTION_BUTTONS.Edit,
    permissionCodes: ['VenuesInventory.HawkerProfile.Manage'],
  },
];
